"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePendingIDSpecificOperation = void 0;
var react_1 = require("react");
var useDitto_1 = require("../useDitto");
function usePendingIDSpecificOperation(params) {
    var liveQueryRef = (0, react_1.useRef)();
    var subscriptionRef = (0, react_1.useRef)();
    var ditto = (0, useDitto_1.useDitto)(params.path).ditto;
    var _a = (0, react_1.useState)(), document = _a[0], setDocument = _a[1];
    var _b = (0, react_1.useState)(), collection = _b[0], setCollection = _b[1];
    var _c = (0, react_1.useState)(), event = _c[0], setEvent = _c[1];
    (0, react_1.useEffect)(function () {
        if (params._id && params.collection && ditto) {
            var nextCollection = ditto.store.collection(params.collection);
            var pendingOperation = nextCollection.findByID(params._id);
            if (!params.localOnly) {
                subscriptionRef.current = pendingOperation.subscribe();
            }
            liveQueryRef.current = pendingOperation.observeLocal(function (doc, e) {
                setEvent(e);
                setDocument(doc);
            });
            setCollection(nextCollection);
        }
        else {
            setDocument(undefined);
            setCollection(undefined);
            setEvent(undefined);
        }
        return function () {
            var _a, _b;
            (_a = liveQueryRef.current) === null || _a === void 0 ? void 0 : _a.stop();
            (_b = subscriptionRef.current) === null || _b === void 0 ? void 0 : _b.cancel();
        };
    }, [params.path, params.collection, params._id || '', ditto]);
    return {
        collection: collection,
        ditto: ditto,
        document: document,
        event: event,
        liveQuery: liveQueryRef.current,
        subscription: subscriptionRef.current,
    };
}
exports.usePendingIDSpecificOperation = usePendingIDSpecificOperation;
//# sourceMappingURL=usePendingIDSpecificOperation.js.map